export default __webpack_public_path__ + "static/media/setion04_bg.34d74df2.jpg";